import { styled, flexColumn } from '@unfold/theme';

export const AddColorContainer = styled.div`
  ${flexColumn}

  .chrome-picker {
    & > div:last-child {
      & > div:last-child {
        display: none !important;
      }
    }

    .hue-horizontal {
      border-radius: 6px;

      & > div > div {
        width: 16px !important;
        height: 16px !important;
        border-radius: 8px !important;
        transform: translate(-8px, -1px) !important;
      }
    }
  }
`;

export const ErrorMessage = styled.div`
  margin-top: 5px;
  color: #aa0000;
  font-size: 12px;
`;
